<template>
  <div>
    <div class="flex">
      <div class="drug_select">
        <DrugSearch
          ref="searchDrug"
          :searchType="searchType"
          :selectedDrug="drug"
          :onSelect="(d) => this.updateDrug(d)"
        />
      </div>
      <div v-if="drug && drug.id" class="drug_line">
        <div class="flex">
          <input @change="updateQty" v-model="qty" type="number" class="form-control">
          <div v-if="drug && drug.cool" class="cool_mark">
            <i class="icon icon-snowflake"/>
          </div>
          <div v-if="drug.id && getDiscountPrices()" class="cool_mark pointer">
            <i class="icon icon-fa icon-fa-percent"
               v-tooltip="{
                      show: toolOpen,
                      placement: 'bottom-center',
                      content: getDiscountPrices(true),
                      classes: 'discount_tooltip tooltip_on_modal'
                    }"
            ></i>
          </div>
          <div v-if="drug && drug.id">
            <v-popover :auto-hide="true" popoverClass="tooltip_on_modal">
              <button
                @click="getDrugInfo()"
                style="height: 38px"
                class="btn btn-info btn-xs border-r-0"
              >
                <i class="icon-fa icon-fa-info"></i>
              </button>

              <template slot="popover">
                <template v-if="!drugInfoLoading">
                  <div v-if="projectInfo[drug.id] && projectInfo[drug.id][$editNewOrder.site_id]">
                    <div class="mb-1" v-html="printDrugInfo(projectInfo[drug.id][$editNewOrder.site_id])"/>
                    <template v-if="projectInfo[drug.id][$editNewOrder.site_id].mirror_sources">
                      <div class="mirror_source_data flex"
                           v-for="source in projectInfo[drug.id][$editNewOrder.site_id].mirror_sources">
                        <div class="w-50 mr-1" v-if="source.data.image"><img :src="source.data.image" alt=""></div>
                        <div>
                          <p>Данные на проекте: <strong>{{ source.title }}</strong></p>
                          <p>препарат: <a :href="`${source.data.link_share ?? source.data.link}`"
                                          target="_blank">{{ source.data.title }}</a></p>
                          <p v-if="source.data.manufacturer">производитель:
                            <strong>{{ source.data.manufacturer }}</strong>
                          </p>
                          <p v-if="source.data.country">страна: <strong>{{ source.data.country }}</strong></p>
                          <p v-if="source.data.block_reason"><strong>препарат НЕ отображается
                            ({{ source.data.block_reason }})</strong></p>
                          <p v-if="source.data.price">цена: <strong>{{ source.data.price }}</strong></p>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div v-else>
                    Нет данных
                  </div>
                </template>
                <template v-else>
                  Загрузка ....
                </template>
                <button v-close-popover class="btn btn-theme btn-sm">
                  Закрыть
                </button>
              </template>
            </v-popover>
          </div>
          <!--          <div v-if="addNewDrug">-->
          <!--            <button @click="addNewDrugRecord" style="height: 38px" class="btn btn-success btn-xs border-r-0">+</button>-->
          <!--          </div>-->
        </div>
        <div class="price_details mt-1">
          <OrderPriceLine :drug="drug"
                          :divId="$editNewOrder.division_id"
                          :discount="discount"
                          :priceDisabled="projectPriceDisabled"
                          :actualPrice="actualPrice"
                          :updatePriceToActual="() => updatePriceToActual()"
                          :priceForActualization="priceForActualization"/>
        </div>
      </div>
    </div>
    <div class="flex">
      <div class="drug_box_info">
        <div class="alert alert-info mb-0 mt-1 p-2"
             v-if="drug && (drug.pack_box_comment || drug.pack_comment)">
          {{ drug.pack_box_comment }}
          <!--          {{ drug.pack_comment }}-->
        </div>
        <template v-if="drug && drug.id && drugInfoRequest">
          <DrugInfo
            ref="drugInfo"
            :drug="drug"
            :locality="$editNewOrder"
            :updateDrug="(d) => this.updateDrug(d, true)"
            :updateTrigger="() => this.updateDeliveryDate && this.updateDeliveryDate()"
          />
          <div class="mt-1" v-if="$refs.drugInfo && +qty > +$refs.drugInfo.actualStoreQty">
            <DeliveryData
              ref="drugDeliveryData"
              :cityId="$editNewOrder.city_id"
              :updateDeliveryDate="updateDeliveryDate"
            />
          </div>
        </template>
      </div>
      <div class="mt-4 pt-2 ml-1" v-if="drug?.id && drugPriceArranged">
        <div class="alert alert-warning w-100 p-2">
          <p>Был заказан</p>
          <p>{{ drugOutsourceData.drug.title }}</p>
          <p><strong>{{ drugOutsourceData.drug.qty }}</strong>уп. по <strong>{{ drugOutsourceData.drug.price }}</strong>р.
            (<strong>{{ drugOutsourceData.drug.qty * drugOutsourceData.drug.price }}</strong>р)
          </p>
        </div>
      </div>
    </div>
    <template v-if="drug?.id">
      <div class="form-group mt-1 mb-1">
        <label for=""><strong>Комментарий к препарату (курьер/склад)</strong></label>
        <div class="drug_comment alert-warning" v-for="(comment, i) in (drug?.extra_data?.comments ?? [])"
             v-if="comment.created_at">
          <p class="mb-0">{{ comment.text }}</p>
          <div class="flex flex_gap_10">
            <p class="mb-0 text-muted">{{ printDate(comment.created_at) }}</p>
            <LoadingButton
              title='<i class="icon-fa icon-fa-remove"/>'
              type="button"
              :loading="removeBtnLoading"
              :color="$constants.WARNING_COLOR"
              :onClick="() => removeComment(drug.id, i)"
              className="btn btn-outline-warning btn-xs"
            />
          </div>
        </div>
        <div v-if="!addNewComment">
          <button @click="addComment" class="btn btn-outline-info btn-xs" type="button">добавить
            комментарий к препарату
          </button>
        </div>
        <div v-else>
          <input type="text" placeholder="комментарий для кладовщика и курьера по препарату"
                 v-model="drug.extra_data.comments[drug.extra_data.comments.length - 1].text"
                 class="form-control">
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import api from '@/api'
import DrugSearch from './DrugSearchData'
import DrugInfo from './DrugInfoForOrder'
import DeliveryData from '@/components/stores/DeliveryData.vue'
import OrderPriceLine from "@/components/drugs/OrderPriceLine.vue";
import moment from "moment";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import DiscountInfoBlock from "@/components/drugs/prices/DiscountInfoBlock.vue";

export default {
  components: {
    DiscountInfoBlock,
    LoadingButton,
    OrderPriceLine,
    DrugSearch,
    DrugInfo,
    DeliveryData,
  },
  props: [
    'extDrug', 'addNewDrug', 'searchType', 'onSelect', 'selectedDrug', 'customData', 'updateDeliveryDate', 'combinedDrugs'
  ],
  data() {
    return {
      projectPriceDisabled: false,
      localCombinedDrugs: [],
      drugPriceArranged: false,
      drugOutsourceData: null,
      priceForActualization: false,
      drug: null,
      qty: 1,
      drugInfoRequest: false,
      toolOpen: false,
      projectInfo: {},
      drugInfoLoading: false,
      actualPrice: 0,
      discount: false,
      lgot: false,
      locality: {},
      addNewComment: false,
      removeBtnLoading: false,
    }
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
  },
  watch: {
    'customData': {
      handler: function (val, oldVal) {
        this.$editNewOrder.city_id = val.city_id;
        this.$editNewOrder.site_id = val.site_id;
      },
      deep: true,
    },
    'drug': {
      handler: function (val, oldVal) {
        this.drugInfoRequest = false
        if (this.drug && this.drug.id) {
          // console.log('drug updated watch ---');
          this.$refs.searchDrug.drug = {...this.drug}
          this.arrangePriceFromOutsource();
          this.updateQty();
          this.drugInfoRequest = true;
        }
      },
    },
    'selectedDrug': {
      handler: function (val, oldVal) {
        // console.log('update drug totally');
        this.drug = {...this.selectedDrug}
      },
      deep: true
    },
  },
  mounted() {
  },
  created() {
    if (this.selectedDrug) {
      this.drug = {...this.selectedDrug}
      this.qty = this.selectedDrug.qty;
      // this.qty = this.selectedDrug.qty / (+this.selectedDrug.pack_set || 1)
      if (this.combinedDrugs) {
        this.localCombinedDrugs = [...this.combinedDrugs];
      }
    }
    if (this.customData) {
      this.$store.dispatch('orders/setEditNewOrder', {extra_options: {}, ...this.$editNewOrder, ...this.customData});
    }
    this.checkPrice();
  },
  methods: {
    async removeComment(drugId, index) {
      this.removeBtnLoading = true;
      const {data} = await api.post('/new/orders/drugs/update', {
        action: 'removeComment',
        order_id: this.$editNewOrder.id,
        drug_id: drugId,
        index
      });
      if (data.success) {
        this.$set(this.drug.extra_data, 'comments', data.record?.extra_data?.comments);
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера', 'Ошибка!');
      }
      this.removeBtnLoading = false;
    },
    allCommentsSaved() {
      // console.log('saved comments');
      (this.drug?.extra_data?.comments ?? []).forEach((c, i) => {
        if (!this.drug.extra_data.comments[i].created_at) {
          this.$set(this.drug.extra_data.comments, i, {
            ...this.drug.extra_data.comments[i],
            created_at: moment().format('YYYY-MM-DD HH:mm:ss')
          })
        }
      })
      this.addNewComment = false;
    },
    addComment() {
      if (!this.drug.extra_data) this.$set(this.drug, 'extra_data', {comments: []});
      if (!this.drug.extra_data.comments) this.$set(this.drug.extra_data, 'comments', []);
      this.drug.extra_data.comments.push({text: null});
      this.addNewComment = true;
    },
    arrangePriceFromOutsource() {
      // console.log('arrange');
      this.drugPriceArranged = false;
      this.drugOutsourceData = null;
      if (!this.$editNewOrder.catalog_order_id || !this.$editNewOrder.extra_options.catalogOrder) return;
      if (!this.drug?.prices) return;

      const projectPrice = this.drug.prices.find((p) => p.is_active && p.site_id === 7 && p.qty === 1);
      if (!projectPrice || (projectPrice.packing && +projectPrice.packing <= 1)) {
        return;
      }
      this.drugOutsourceData = {drug: this.$editNewOrder.extra_options.extra_drugs.find((d) => d.drug_id === this.drug.id)};
      this.drugPriceArranged = true;
    },
    checkPrice() {
      this.priceForActualization = false;
      if (!this.drug) return;
      if (+this.$editNewOrder.status === 8) {
        const price = this.getPriceByQty(null, false);
        this.priceForActualization = +this.drug.actual_price !== +price;
      }
    },
    updatePriceToActual() {
      // console.log('update actual price');
      const price = this.getPriceByQty(null, false);
      let currency_price = null;
      if (this.$editNewOrder.currency_id && this.drug.detail_id && ([1, 2, 3, 11].includes(+this.$editNewOrder.status) || this.$editNewOrder.type_id === 2)) {
        currency_price = this.drug.currency_price;
      }
      if (this.onSelect) {
        this.onSelect({...this.drug, qty: this.qty, actualPrice: price, actual_price: price}, true)
        setTimeout(() => {
          this.drug = {...this.selectedDrug, currency_price}
          this.checkPrice();
        }, 200)
      }
      // console.log(price);
      this.actualPrice = price;
    },
    updateDrug(d, force = false) {
      // console.log(d, force);
      if (force) {
        this.drug = {...d};
        return;
      }
      if (!d && this.$editNewOrder && this.$editNewOrder.id) {
        this.$editNewOrder.details = this.$editNewOrder.details.filter((det) => det.drug_id !== this.drug.id && det.type_id === 0);
      }
      if (d?.id) {
        if ((this.$editNewOrder.drugs || []).find((drug) => drug.id === d.id && drug.type_id === 0)) {
          this.drug = null;
          this.$refs.searchDrug.drug = null;
          if (this.onSelect) {
            this.onSelect(null)
          }
          console.log('drug already selected');
          return;
        }
      }
      if (((!this.drug || !this.drug.id) && d && d.id)
        || (this.drug && this.drug.id && d && d.id !== this.drug.id)) {
        // console.log('update selected drug');
        this.drug = d
        this.$refs.searchDrug.drug = {...this.drug}
        // if (d.pack_set) {
        //   this.qty = +d.pack_set
        // }
        this.updateQty()
        if (!this.selectedDrug) {
          this.$refs.searchDrug.drug = null
          this.$refs.searchDrug.options = []
        }
        if (this.drug && this.drug.id) {
          setTimeout(() => {
            this.$refs.drugInfo.getInfo()
          }, 200)
        }
      } else {
        if (this.onSelect) {
          this.onSelect(null)
        }
      }
      this.checkPrice();
    },
    getPriceByQty(selectedSiteId = null, fromSavedDrug = true) {
      this.projectPriceDisabled = false;
      // console.log('price update by prices', selectedSiteId, fromSavedDrug);
      // if ((selectedSiteId || +this.$editNewOrder.site_id) === 4) {
      // return this.getPriceByQty(12);
      // }
      const siteId = +this.$editNewOrder.site_id === 14 ? 13 : +this.$editNewOrder.site_id;
      // console.log('siteId: ' + siteId);
      let price = 0
      if (!this.drug?.id) {
        // console.log('no drug');
        return price
      }
      if (this.drug.detail_id && ([1, 2, 3, 11].includes(+this.$editNewOrder.status) || this.$editNewOrder.type_id === 2)) {
        // console.log('refund price');
        return this.drug.actual_price
      }
      let sortedPrices = _.orderBy((this.drug && this.drug.prices || []), 'qty', 'desc')
      const clearedQty = Math.abs(this.qty)
      if (!selectedSiteId) selectedSiteId = +this.$editNewOrder.site_id;
      const savedDrug = (this.$editNewOrder.details || []).find((d) => d.drug_id === this.drug.id);
      const savedDrugWPrice = (this.$editNewOrder.drugs || []).find((d) => d.id === this.drug.id);

      sortedPrices.forEach((p, i) => {
        // console.log(i, p.site_id, p.qty, +p.site_id === (selectedSiteId ?? siteId), clearedQty >= p.qty, p.is_active, price === 0, p);
        if (price > 0) return
        if (+p.site_id === (selectedSiteId ?? siteId) && clearedQty >= p.qty && p.is_active && price === 0) {
          // console.log('pass', p);
          if (fromSavedDrug && savedDrug && savedDrug.id) {
            if (clearedQty >= +savedDrug.qty) {
              if (p.qty > 1) this.discount = true;
              // price = savedDrug.price;
              price = savedDrugWPrice && savedDrugWPrice?.actualPrice || savedDrug.price;
              return;
            }
          }
          price = +p.price
          if (p.qty > 1) {
            this.discount = true
          }
        }
      })

      if (!price) {
        const p = sortedPrices.find((p) => +p.site_id === (selectedSiteId ?? siteId) && clearedQty >= p.qty);
        if (p) {
          price = +p.price;
          if (!p.is_active) this.projectPriceDisabled = true;
        }
      }

      // console.log(sortedPrices, price);
      if (price === 0) {
        if (!sortedPrices || !sortedPrices.length) {
          toastr['warning'](
            'Препарат ' + (this.drug.title || '') + ' не имеет активной цены'
          )
        }
      }
      if (price === 0) {
        // console.log(price);
        if (+selectedSiteId !== 1) {
          price = this.getPriceByQty(1);
        }
        if (price === 0) {
          const siteId = (this.drug && this.drug.prices || []).find((p) => p.qty === 1 && p.is_active);
          if (siteId) return this.getPriceByQty(siteId.site_id);
        }
      }
      return price
    },
    updateQty() {
      // console.log('qty updated');
      // console.log('update qty', this.drug);
      this.discount = false
      // const price = this.selectedDrug && this.selectedDrug.detail_id ? this.selectedDrug.actual_price : this.getPriceByQty();
      const price = this.getPriceByQty();
      console.log(price);
      this.actualPrice = price
      const index = this.$editNewOrder.drugs.findIndex((d) => d.id === this.drug.id);
      if (index !== -1) {
        this.$editNewOrder.drugs[index].qty = this.qty;
        this.$editNewOrder.drugs[index].actual_price = price;
        // this.drug.qty = this.qty;
      } else {
        this.onSelect({...this.drug, qty: this.qty, actualPrice: price, actual_price: price})
        this.drug = null;
      }
      // if (this.onSelect) {
      //   if (this.drug) {
      //     this.onSelect({...this.drug, qty: this.qty, actualPrice: price, actual_price: price})
      // } else {
      // this.onSelect({});
      // }
      // }
    },
    printDrugInfo(data) {
      if (data.error) {
        return '<p class="color-red">' + data.error + '</p>'
      }
      let text = `<p>Препарат <a href="${data.link_share ?? data.link}" target="_blank">${data.title}</a></p>`
      if (data.image_full) {
        text += `<div><img src="${data.image_full}" alt=""></div>`;
      }
      if (data.manufacturer) {
        text += `<p>производитель: <strong>${data.manufacturer}</strong></p>`;
      }
      if (data.country) {
        text += `<p>страна: <strong>${data.country}</strong></p>`;
      }
      return text
    },
    async getDrugInfo() {
      if (this.projectInfo[this.drug.id] && this.projectInfo[this.drug.id][this.$editNewOrder.site_id]) return
      this.drugInfoLoading = true

      const {data} = await api.post('/new/drugs/infoType', {
        types: ['projectInfo', 'siteDetails'],
        drug_id: this.drug.id,
        project_id: this.$editNewOrder.site_id || this.customData.site_id
      })

      if (!this.projectInfo[this.drug.id]) {
        this.projectInfo[this.drug.id] = {};
        this.projectInfo[this.drug.id][this.$editNewOrder.site_id] = {};
      }
      if (data.success) {
        this.projectInfo[this.drug.id][this.$editNewOrder.site_id] = data
      } else {
        this.projectInfo[this.drug.id][this.$editNewOrder.site_id] = false
      }
      this.drugInfoLoading = false
    },
    getDiscountPrices(print = false) {
      let prices = 0
      let text = ''
      if (!this.drug.prices) {
        return text
      }
      // console.log(this.drug.prices, this.$editNewOrder.site_id, this.drug.prices.filter((p) => +p.site_id === +this.$editNewOrder.site_id && p.is_active));
      this.drug.prices.forEach(p => {
        if (+p.site_id === +this.$editNewOrder.site_id) {
          if (+p.qty === 1 && !p.is_active) return;
          const pieces = +this.drug.pack_set === 1 ? 'шт' : 'компл';
          text += `<p>от ${p.qty} ${pieces}. цена <strong>${p.price * this.drug.pack_set}</strong> руб.</p>`;
          ++prices
        }
      })
      if (!print) return prices > 1 ? true : false
      return text
    },
  }
}

</script>

<style>
.discount_tooltip {
  top: 1px !important;
  left: -2px !important;
  background-color: white;
  border: 1px solid #ced4da;
  padding-top: 15px !important;
}

.tooltip-inner {
  background: white !important;
  color: #333 !important;
  max-width: max-content !important;
}
</style>

<style scoped>
.drug_comment {
  display: flex;
  justify-content: space-between;
  padding: 5px;
  border: 1px solid darkred;
  margin-bottom: 5px;
}

.fs-12 {
  font-size: 12px;
}

.drug_box_info {
  width: calc(100% - 200px);
  min-width: calc(100% - 200px);
}

.drug_line {
  position: relative;
}

.price_details {
  text-align: right;
  position: absolute;
  right: 0;
}

.price_details p {
  margin-bottom: 1px;
}

.actual_drug_price {
  background-color: #4fc47f;
  color: white;
  padding: 2px 5px;
  font-weight: bold;
}

.drug_select {
  min-width: calc(100% - 200px);
}

.drug_select_div .badge.badge-success {
  color: white;
}

.drug_select_div .d-center {
  display: flex;
  align-items: center;
}

.cool_mark .icon.icon-fa-percent {
  color: #5bbfde;
  background: white;
}

.cool_mark {
  padding: 0 4px;
  border: 1px solid #ced4da;
  border-left: 0;
  height: 38px;
}

.cool_mark .icon {
  text-align: center;
  display: inline-block;
  vertical-align: -webkit-baseline-middle;
}

.btn i {
  text-align: center;
  width: auto !important;
}

.alert-warning p {
  margin-bottom: 0;
}

.icon {
  display: block;
  width: 17px;
  height: 19px;
  background: #5bbfde;
  margin: 0 auto;
}

.mirror_source_data {
  padding: 3px;
  border: 1px solid lightgray;
  margin-bottom: 3px;
}

.btn,
input {
  border-radius: 0
}
</style>
